import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';
import logo from '../../Assets/CreArt.png';
import { showDate } from '../../constant';
import { staffImage } from '../../helpers';

const ViewTutor = () => {
  let location = useLocation();
  let navigate = useNavigate();
  let data = location.state;
  
  const [isPhotoOpen, setIsPhotoOpen] = useState(false);
  const [isAadharOpen, setIsAadharOpen] = useState(false);
  const [isPanOpen, setIsPanOpen] = useState(false);
  const [isChequeOpen, setIsChequeOpen] = useState(false);
  const Photo = `${staffImage}/${data.photo}`;
  const aadharCard = `${staffImage}/${data.aadhar_card}`;
  const panCard = `${staffImage}/${data.pan_card}`;
  const cheque = `${staffImage}/${data.bank_cheque}`;

  return (
    <div className='grow ms-0 md:ms-0 lg:ms-56 relative'>
      <div className="px-4 mt-6 mb-8 sm:px-6 lg:px-8">
        <div className="xl:flex xl:items-center xl:justify-between">
          <h1 className="hidden text-2xl font-semibold text-primary-600 lg:block">
            Staff Details
          </h1>
          <button type="button" className="btn btn-white" onClick={() => navigate('/dashboard/staff/')}>
            Back
          </button>
        </div>

        <div className="mt-8 md:mt-6 sm:flex sm:items-center sm:space-x-6">
          <div className="flex items-center space-x-3">
            <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
              <polyline points="80 40 24 128 80 216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></polyline>
              <polyline points="176 40 232 128 176 216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></polyline>
            </svg>
            <span className="text-gray-600">
              {data._id}
            </span>
          </div>

          <div className="flex items-center mt-3 space-x-3 sm:mt-0">
            <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
              <rect x="40" y="40" width="176" height="176" rx="8" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" fill="none"></rect>
              <line x1="176" y1="20" x2="176" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
              <line x1="80" y1="20" x2="80" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
              <line x1="40" y1="88" x2="216" y2="88" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
            </svg>
            <span className="text-gray-600">
              Created - <span>{data.created_at}</span>
            </span>
          </div>

          <div className="flex items-center mt-3 space-x-3 sm:mt-0">
            <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
              <rect x="40" y="40" width="176" height="176" rx="8" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" fill="none"></rect>
              <line x1="176" y1="20" x2="176" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
              <line x1="80" y1="20" x2="80" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
              <line x1="40" y1="88" x2="216" y2="88" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
            </svg>
            <span className="text-gray-600">
              Updated - <span>{data.updated_at}</span>
            </span>
          </div>

          <div className="flex items-center mt-3 space-x-3 sm:mt-0">
            <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
              <rect x="40" y="40" width="176" height="176" rx="8" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" fill="none"></rect>
              <line x1="176" y1="20" x2="176" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
              <line x1="80" y1="20" x2="80" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
              <line x1="40" y1="88" x2="216" y2="88" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
            </svg>
            <span className="text-gray-600">
              Deleted - <span>{showDate(data.deleted_at)}</span>
            </span>
          </div>
        </div>
        <div className="mt-2 space-y-6">
          <div className="overflow-hidden bg-white rounded-lg shadow">
            <div className="px-4 py-5 sm:p-6">
              <div className="grid xl:grid-cols-6 gap-y-10">
                <div className="xl:col-span-4 xl:pr-8">
                  <div className="space-y-6">
                    <div>
                      <div className="flex items-center">
                        <p className="font-medium">
                          Staff Details
                        </p>
                      </div>

                      <div className="mt-3 space-y-3">
                        <div className="bg-white border border-gray-100 rounded-lg shadow-md">
                          <div className="px-4 py-5 sm:p-6">

                            <div className='flex justify-between !items-end'>
                              <div>
                                <p className="text-sm text-gray-600">
                                  Name
                                </p>
                                <h3 className="text-2xl font-bold text-primary-600">
                                  {data.firstname + " " + data.lastname}
                                </h3>
                              </div>

                              <div>
                                <p className="text-sm text-gray-600">
                                  Experties
                                </p>
                                <p className="mt-1 text-xl leading-tight text-primary-600">
                                  {data.experties}
                                </p>
                              </div>
                            </div>

                            <div className="grid grid-cols-2 gap-5 mt-5 sm:grid-cols-1 xl:grid-cols-2">
                              <div className='col-span-2 sm:col-span-2 lg:col-span-1 md:col-span-2'>
                                <p className="text-sm text-gray-600">
                                  Contact
                                </p>
                                <p className="mt-1">
                                  {data.mobile}
                                </p>
                              </div>

                              <div className='col-span-2 sm:col-span-2 lg:col-span-1 md:col-span-1'>
                                <p className="text-sm text-gray-600">
                                  Email
                                </p>
                                <p className="mt-1">
                                  {data.email}
                                </p>
                              </div>

                              <div>
                                <p className="text-sm text-gray-600">
                                  Date of Birth
                                </p>
                                <p className="mt-1">
                                  {showDate(data.dob)}
                                </p>
                              </div>

                              <div>
                                <p className="text-sm text-gray-600">
                                  Address
                                </p>
                                <p className="mt-1">
                                  {data.address}
                                </p>
                              </div>

                              <div>
                                <p className="text-sm text-gray-600">
                                  Staff Type
                                </p>
                                <p className="mt-1">
                                  {data.staff_type}
                                </p>
                              </div>

                              <div>
                                <p className="text-sm text-gray-600">
                                  Gender
                                </p>
                                <p className="mt-1">
                                  {data.gender}
                                </p>
                              </div>

                              <div>
                                <p className="text-sm text-gray-600">
                                  Photo
                                </p>
                                <div className='mt-1 cursor-pointer' onClick={() => { setIsPhotoOpen(true) }}>
                                  <div className='flex gap-2 items-center'>
                                    {/* {data.photo} */}Photo
                                    <svg className="w-5 h-5" stroke="currentColor" viewBox="0 0 256 256">
                                      <path d="M128,55.99219C48,55.99219,16,128,16,128s32,71.99219,112,71.99219S240,128,240,128,208,55.99219,128,55.99219Z" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></path>
                                      <circle cx="128" cy="128" r="32" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></circle>
                                    </svg>
                                  </div>
                                </div>
                                {
                                  isPhotoOpen &&
                                  <div className='bg-black bg-opacity-50 absolute w-full h-full z-[888] bottom-0 right-0'>
                                    <div className='flex justify-center !items-center h-full'>
                                      <div className='flex justify-center w-100 h-100'>
                                        <div className='w-1/2'>
                                          <img src={Photo} className='w-100 h-100' alt="" />
                                        </div>
                                        <div>
                                          <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={() => setIsPhotoOpen(false)}>
                                            <span className="sr-only">
                                              Close
                                            </span>
                                            <svg className="w-6 h-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                }
                              </div>

                              <div>
                                <p className="text-sm text-gray-600">
                                  Aadhar Id
                                </p>
                                <div className="mt-1 cursor-pointer" onClick={() => setIsAadharOpen(true)}>
                                  <div className='flex gap-2 items-center'>
                                    {/* {data.aadhar_card} */}Aadhar Card
                                    <svg className="w-5 h-5" stroke="currentColor" viewBox="0 0 256 256">
                                      <path d="M128,55.99219C48,55.99219,16,128,16,128s32,71.99219,112,71.99219S240,128,240,128,208,55.99219,128,55.99219Z" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></path>
                                      <circle cx="128" cy="128" r="32" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></circle>
                                    </svg>
                                  </div>
                                </div>
                                {
                                  isAadharOpen &&
                                  <div className='bg-black bg-opacity-50  w-full h-full z-[888] absolute bottom-0 right-0'>
                                    <div className='flex justify-center !items-center h-full'>
                                      <div className='flex justify-center w-100 h-100'>
                                        <div className='w-1/2'>
                                          <img src={aadharCard} className='w-100 h-100'  alt="Aadhar" />
                                        </div>
                                        <div>
                                          <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={() => setIsAadharOpen(false)}>
                                            <span className="sr-only">
                                              Close
                                            </span>
                                            <svg className="w-6 h-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                }
                              </div>

                              <div>
                                <p className="text-sm text-gray-600">
                                  Join Date
                                </p>
                                <p className="mt-1">
                                  {showDate(data.joining_date)}
                                </p>
                              </div>

                              <div>
                                <p className="text-sm text-gray-600">
                                  Status
                                </p>
                                <div className="toggle-switch mt-1">
                                    <input type="checkbox" checked={true} id="toggleSwitch" tabIndex="0" readOnly />
                                    <label htmlFor="toggleSwitch"></label>
                                  </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="xl:border-l xl:border-gray-200 xl:col-span-2 xl:pl-8">
                  <div className="flex items-center justify-between">
                    <p className="font-medium">
                      Bank Details
                    </p>
                  </div>

                  <div className="grid grid-cols-2 mt-8 gap-x-8 gap-y-6">

                    <div >
                      <p className="text-sm text-gray-600">
                        Bank Name
                      </p>
                      <p className="mt-1 text-xl leading-tight text-primary-600">
                        {data.staffdetails.bank_name}
                      </p>
                    </div>

                    <div >
                      <p className="text-sm text-gray-600">
                        Account Number
                      </p>
                      <p className="mt-1 text-xl leading-tight text-primary-600">
                        {data.staffdetails.account_no}
                      </p>
                    </div>

                    <div>
                      <p className="text-sm text-gray-600">
                        Account Holder Name
                      </p>
                      <p className="mt-1">
                        {data.staffdetails.account_holder_name}
                      </p>
                    </div>

                    <div>
                      <p className="text-sm text-gray-600">
                        Account Type
                      </p>
                      <p className="mt-1">
                        {data.staffdetails.account_type}
                      </p>
                    </div>

                    <div>
                      <p className="text-sm text-gray-600">
                        IFSC Code
                      </p>
                      <p className="mt-1">
                        {data.staffdetails.ifsc_code}
                      </p>
                    </div>

                    <div>
                      <p className="text-sm text-gray-600">
                        Type of Salery
                      </p>
                      <p className="mt-1">
                        {data.staffdetails.type_of_salary}
                      </p>
                    </div>

                    <div>
                      <p className="text-sm text-gray-600">
                        Pan card
                      </p>
                      <div className="mt-1 cursor-pointer" onClick={() => setIsPanOpen(true)}>
                        <div className='flex gap-2 items-center'>
                          {/* data.studentData.address */} Pan Card
                          <svg className="w-5 h-5" stroke="currentColor" viewBox="0 0 256 256">
                            <path d="M128,55.99219C48,55.99219,16,128,16,128s32,71.99219,112,71.99219S240,128,240,128,208,55.99219,128,55.99219Z" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></path>
                            <circle cx="128" cy="128" r="32" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></circle>
                          </svg>
                        </div>
                      </div>
                      {
                        isPanOpen &&
                        <div className='bg-black bg-opacity-50 absolute w-full h-full z-[888]  bottom-0 right-0'>
                          <div className='flex justify-center !items-center h-full'>
                            <div className='flex justify-center w-100 h-100'>
                              <div className='w-1/2'>
                                <img src={panCard} className='w-100 h-100' alt="pan" />
                              </div>
                              <div>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={() => setIsPanOpen(false)}>
                                  <span className="sr-only">
                                    Close
                                  </span>
                                  <svg className="w-6 h-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                  </svg>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>

                    <div>
                      <p className="text-sm text-gray-600">
                        Cancelled Cheque
                      </p>
                      <div className="mt-1 cursor-pointer" onClick={() => setIsChequeOpen(true)}>
                        <div className='flex gap-2 items-center'>
                          {/* data.studentData.address */} Cheque
                          <svg className="w-5 h-5" stroke="currentColor" viewBox="0 0 256 256">
                            <path d="M128,55.99219C48,55.99219,16,128,16,128s32,71.99219,112,71.99219S240,128,240,128,208,55.99219,128,55.99219Z" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></path>
                            <circle cx="128" cy="128" r="32" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></circle>
                          </svg>
                        </div>
                      </div>
                      {
                        isChequeOpen &&
                        <div className='bg-black bg-opacity-50 absolute w-full h-full z-[888] bottom-0 right-0'>
                          <div className='flex justify-center !items-center h-full'>
                            <div className='flex justify-center'>
                              <div className='w-1/2'>
                                <img src={cheque} className='w-100 h-100' alt="cheque" />
                              </div>
                              <div>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={() => setIsChequeOpen(false)}>
                                  <span className="sr-only">
                                    Close
                                  </span>
                                  <svg className="w-6 h-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                  </svg>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                  <hr className="my-6 border-gray-200" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ViewTutor
